<!-- Copyright 2019, Nathan Lecompte -->

<template>
    <section class="s-res-item" v-if="item.title&&item.desc">
        <section class="s-res-image" v-if="item.img">
            <img :src="item.img" :alt="item.title"/>
        </section>
        <h2>{{ item.title }}</h2>
        <p>{{ item.desc }}
            <ul v-if="item.snippets.length!=0">
                <li v-for="snippet in item.snippets" :key="snippet.id">
                    <b>{{ snippet.title }}</b>{{ snippet.content }}
                </li>
            </ul>
        </p>
        <ul class="s-res-links" v-if="item.links.length!=0">
            <li v-for="link in item.links" :key="link.id">
                <a :href="link.url" tabindex="3">{{ link.title }}</a>/
            </li>
        </ul>
    </section>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>